import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';

import Modal from 'components/Modal';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceAccountsList } from 'containers/ConnectionManager/actions';

import Sidebar from 'Workspace/components/WorkspaceSidebar';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import { selectAccountsList } from 'Workspace/Admin/store/selectors';
import { accountShape } from 'Workspace/types/account';
import gtmService from 'utils/gtm/gtmService';

import AdminNavigation from '../AdminNavigation';
import CreateAccountModal from './components/CreateAccountModal';
import AccountsList from './components/AccountsList';

import messages from './messages';
import { pageName, GTM_EVENT_TYPES } from 'utils/gtm/constants';

class AccountsPage extends React.Component {
  state = {
    showCreateAccountModal: false,
  }

  componentDidMount() {
    this.props.getAccounts();
    gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: pageName.ACCOUNTS_PAGE } });
  }

  toggleCreateAccountModal = () => {
    this.setState({
      showCreateAccountModal: !this.state.showCreateAccountModal,
    });
  }

  render() {
    const { showCreateAccountModal } = this.state;
    const { accounts } = this.props;
    const accountsList = _.values(accounts);

    return (
      <PageWrapper>
        <Sidebar navigation={<AdminNavigation selectedKey="accounts" />} />
        <Modal
          visible={showCreateAccountModal}
          onDismiss={this.toggleCreateAccountModal}
          title={intl.formatMessage(messages.newAccount)}
        >
          <CreateAccountModal onDismiss={this.toggleCreateAccountModal} />
        </Modal>
        <PageViewport>
          <WorkspaceHeader title={intl.formatMessage(messages.accounts)} />
          <PageActions>
            <PageActionsRight>
              <Button primary onClick={this.toggleCreateAccountModal}>
                <MaterialIcon left id="add" />
                {intl.formatMessage(messages.account)}
              </Button>
            </PageActionsRight>
          </PageActions>
          <PageContent>
            <AccountsList accounts={accountsList} />
          </PageContent>
        </PageViewport>
      </PageWrapper>
    );
  }
}

AccountsPage.propTypes = {
  accounts: PropTypes.objectOf(accountShape),
  getAccounts: PropTypes.func,
  location: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  getAccounts: () => dispatch(commandWorkspaceAccountsList()),
});

const mapStateToProps = (state) => ({
  accounts: selectAccountsList(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountsPage);
